export function malay(odd: number): string {
  let fvalue: number
  if (odd <= 2) {
    fvalue = odd - 1
  } else {
    fvalue = -1 / (odd - 1)
  }
  return fvalue.toFixed(2)
}
